import { Component, OnInit } from "@angular/core";
import { DashboardResponseDTO } from "../models/DashboardResponseDTO";
import { Observable, Subscription } from "rxjs";
import { DashboardService } from "../services/Dashboard.service";

import { environment } from "src/environments/environment";
import { AuthService } from "src/app/features/pages/authmanagement/services/Auth.service";
import { LocalStorageService } from "src/app/features/shared/services/LocalStorage.service";
import { SessionService } from "src/app/features/shared/services/Session.service";

@Component({
  selector: "app-dashboardPage",
  templateUrl: "./dashboardPage.component.html",
  styleUrls: ["./dashboardPage.component.css"],
})
export class DashboardPageComponent implements OnInit {
  isAdmin: boolean = false;
  roles: string[];
  dataResume: DashboardResponseDTO = new DashboardResponseDTO();
  isMapix: boolean = false;
  IsAuthenticated: boolean;
  public isLoading: boolean = false;
  public $isLoading: Observable<boolean> = new Observable<boolean>();
  private config: { version: string };

  subscription_CheckAuthentication: Subscription;
  subscription_getLoading: Subscription;
  subscription_getAPIversion: Subscription;
  subscription: Subscription;

  constructor(
    private authService: AuthService,
    private dashboardService: DashboardService,
    private sessionService: SessionService,
    private localStorageService: LocalStorageService
  ) {
    this.subscription_getLoading =this.dashboardService.getLoading().subscribe((data: boolean) => {
      this.isLoading = data;
    });
  }

  ngOnInit() {
    this.sessionService.setIsExternalMap(false);
    this.config = require("src/assets/config.json");

    if(!environment.production) console.log("Version ", this.config.version);
    this.subscription_getAPIversion = this.sessionService.getAPIversion().subscribe({
      next: (data) => {
        if (
          this.localStorageService.getVersion() == null ||
          this.localStorageService.getVersion() !== data
        ) {
          this.localStorageService.setVersion(data);
          // Las versiones no coinciden, así que recargamos la aplicación
          // location.reload();
        }
      },
      error: (error) => {
        // TODO marca para complete despues
        console.error('Error al obtener version de API', error);
      }
    });

    // this.CheckAuthentication();
    // if (this.IsAuthenticated) {
    //   this.isMapix = this.sessionService.isMapix;
    // }
  }


  ngOnDestroy() {
    if (this.subscription_CheckAuthentication)
      this.subscription_CheckAuthentication.unsubscribe();
    if (this.subscription_getLoading)
      this.subscription_getLoading.unsubscribe();
    if (this.subscription_getAPIversion)
      this.subscription_getAPIversion.unsubscribe();
  }

  CheckAuthentication() {
    this.subscription_CheckAuthentication = this.authService
      .checkAuthenticated()
      .subscribe((arg) => (this.IsAuthenticated = arg));
    if(!environment.production) console.log("Authenticated:" + this.IsAuthenticated);
  }

}